import { UILocation } from "@1js/acui-common";

/**
 * Since we can have controls in multiple locations that share models but not props. Add a way to ensure we get a unique id for each location during
 * memoization in order to prevent uneeded rerenders.
 */
export function createIdForMemoization(
  id: string,
  location?: UILocation,
  suffix?: string
) {
  return location
    ? suffix
      ? `${id}-${location.toString()}-${suffix}`
      : `${id}-${location.toString()}`
    : id;
}
